import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactDatetimeClass from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import { useTranslation } from 'react-i18next';

const Datetime = ReactDatetimeClass.default ?? ReactDatetimeClass;

import './style.scss';

function PeriodSelect({ sessionsInterval, setDates }) {
  const [startDate, setStartDate] = useState(
    sessionsInterval ? sessionsInterval.start : moment().startOf('day')
  );
  const [endDate, setEndDate] = useState(
    sessionsInterval ? sessionsInterval.end : moment().endOf('day')
  );
  const [interval, setInterval] = useState(sessionsInterval ? '' : 'day');
  const { t } = useTranslation();

  useEffect(() => {
    setDates(startDate, endDate);
  }, [startDate, endDate]);

  const setPeriod = (val = 'day') => {
    let start = null;
    let end = moment();

    switch (val) {
      case 'day':
        start = moment().startOf('day');
        break;
      case 'week':
        start = moment().startOf('week').add(1, 'days');
        break;
      case 'month':
        start = moment().startOf('month');
        break;
      default:
        throw new Error("Invalid interval type. Must be one of 'day', 'week', or 'month'");
    }
    setInterval(val);
    setStartDate(start);
    setEndDate(end);
  };

  const disableFutureDt = (current) => {
    const today = moment();
    return current.isBefore(today);
  };

  const startBeforeEndDate = (current) => {
    return current.isBefore(endDate);
  };

  return (
    <div className='page-date-filter'>
      <div>
        <div className='period-select'>
          <div className={interval === 'day' ? 'selected' : ''} onClick={() => setPeriod('day')}>
            {t('today')}
          </div>
          <div className={interval === 'week' ? 'selected' : ''} onClick={() => setPeriod('week')}>
            {t('this_week')}
          </div>
          <div
            className={interval === 'month' ? 'selected' : ''}
            onClick={() => setPeriod('month')}>
            {t('this_month')}
          </div>
        </div>
        <div className='date-range'>
          <div className='date-range__start date-range__input'>
            <Datetime
              initialValue={startDate}
              isValidDate={startBeforeEndDate}
              value={startDate}
              timeFormat={false}
              closeOnSelect={true}
              dateFormat='MMMM Do'
              onChange={(val) => {
                setInterval('');
                setStartDate(moment(val).startOf('day'));
              }}
            />
          </div>
          <div className='date-range__end date-range__input'>
            <Datetime
              initialValue={endDate}
              value={endDate}
              closeOnSelect={true}
              timeFormat={false}
              dateFormat='MMMM Do'
              isValidDate={disableFutureDt}
              onChange={(val) => {
                setInterval('');
                setEndDate(moment(val).endOf('day'));
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
PeriodSelect.propTypes = {
  setDates: PropTypes.func.isRequired,
  sessionsInterval: PropTypes.object
};

export default PeriodSelect;
